<template>
  <card-item card="item_user_stat" :user="item" :tabs="tabs" :activeTab="activeTab" :id="id">
  </card-item>
</template>
<script>
import { cardUpdate, cardContent, pushLang } from "@/plugins/functions";
export default {
  async created() {
    this.item = await this.cardContent('ratings', this.id);
  },
  methods: {
    cardContent: cardContent,
  },
  props: ["id"],
  data() {
    return {
      item: null,
      tabs: [
        {
          title: "Информация",
          component: () => import("./Info"),
        },
        {
          title: "Заказы",
          component: () => import("./Orders"),
        },
        {
          title: "Торговые точки",
          component: () => import("./Shops"),
        },
        {
          title: "Передвижение",
          component: () => import("./Map"),
          keepAlive:true
        },
        {
          title: "Отчет по передвижениям",
          component: () => import("./Roads"),
          keepAlive:true
        },
      ],
      activeTab: 0,
    };
  },
};
</script>